import { createReducer } from '@reduxjs/toolkit';
import without from 'lodash/without';
import {
    removeBusiness,
    setBusinessCollection,
    setBusinessCollectionFilters,
    setBusinessCollectionLoading,
    setBusinessRecords,
    setBusinessSubscription,
} from './actions';
import type { BusinessDataModel } from './types';

const DEFAULT_COLLECTION_STATE = {
    identifiers: [],
    isLoading: false,
};

interface BusinessCollection {
    identifiers: string[];
    isLoading: boolean;
    filters: Record<string, any>;
}

interface BusinessState {
    records: Record<string, BusinessDataModel>;
    collections: Record<string, BusinessCollection>;
}

export const businessReducer = createReducer<BusinessState>(
    {
        records: {},
        collections: {},
    },
    (builder) => {
        builder
            .addCase(setBusinessRecords, (draft, action) => {
                action.payload.forEach((nextModel) => {
                    const prevModel = draft.records[nextModel.publicId];

                    // Перезаписываем только более полную по данным модель
                    if (
                        !prevModel ||
                        prevModel.__type === 'lite' ||
                        nextModel.__type === 'standard'
                    ) {
                        draft.records[nextModel.publicId] = nextModel;
                    }
                });
            })

            .addCase(setBusinessSubscription, (draft, action) => {
                const { businessId, subscribed } = action.payload;

                if (draft.records[businessId]) {
                    draft.records[businessId].subscribed = subscribed;
                }
            })

            .addCase(setBusinessCollectionLoading, (draft, action) => {
                const { namespace, isLoading } = action.payload;

                draft.collections[namespace] = draft.collections[namespace] ?? {
                    ...DEFAULT_COLLECTION_STATE,
                };

                draft.collections[namespace].isLoading = isLoading;
            })

            .addCase(setBusinessCollectionFilters, (draft, action) => {
                const { namespace, filters } = action.payload;

                draft.collections[namespace] = draft.collections[namespace] ?? {
                    ...DEFAULT_COLLECTION_STATE,
                };

                draft.collections[namespace].filters = filters;
            })

            .addCase(setBusinessCollection, (draft, action) => {
                const { namespace, identifiers } = action.payload;

                draft.collections[namespace] = draft.collections[namespace] ?? {
                    ...DEFAULT_COLLECTION_STATE,
                };

                draft.collections[namespace].identifiers = [...identifiers];
            })
            .addCase(removeBusiness, (draft, action) => {
                const businessId = action.payload;

                delete draft.records[businessId];
                Object.keys(draft.collections).forEach((collectionKey) => {
                    draft.collections[collectionKey].identifiers = without(
                        draft.collections[collectionKey].identifiers,
                        businessId,
                    );
                });
            });
    },
);
